import {
  hideAppBar,
  showInfoMessage,
  showWarningMessage,
} from '../routines/notificationRoutines';
import { SESSION_EXPIRED_ERROR } from '../../common/constants/CommonConstants';
import { isNonProd } from '../../envUtils';

const initialState = {
  primaryAlert: {
    message: 'AAAA',
    type: 'error', // error,info,success
    show: false,
    errorData: null,
  },
  secondaryAlert: {
    message: '',
    type: 'warning',
    show: false,
    errorData: null,
  },
};
const DEFAULT_MESSAGE =
  'Oops, something went wrong somewhere. You may want to refresh and try again.';
const appbarReducer = (state = initialState, action) => {
  switch (action.type) {
    case hideAppBar.TRIGGER: {
      return {
        ...state,
        primaryAlert: {
          ...state.primaryAlert,
          message: null,
          show: false,
          errorData: null,
        },
      };
    }
    case showInfoMessage.TRIGGER: {
      return {
        ...state,
        primaryAlert: {
          ...state.primaryAlert,
          message: action.payload.message,
          show: true,
          type: 'info',
          errorData: null,
        },
      };
    }
    case showWarningMessage.SUCCESS: {
      if (action.payload?.warningMessage) {
        return {
          ...state,
          secondaryAlert: {
            ...state.secondaryAlert,
            message: action.payload.message,
            show: true,
            type: 'warning',
            errorData: null,
          },
        };
      }
      return {
        ...state,
        secondaryAlert: {
          ...state.secondaryAlert,
          show: false,
        },
      };
    }
    case (action.type.match(/SUCCESS$/) || {}).input: {
      if (action.payload?.successMessage) {
        const { successMessage: message } = action.payload;
        return {
          ...state,
          primaryAlert: {
            ...state.primaryAlert,
            message,
            show: true,
            errorData: null,
            type: 'success',
          },
        };
      }
      return state;
    }

    case (action.type.match(/FAILURE$/) || {}).input: {
      console.error('(!!!) ERROR:', action);
      const _defaultMessage = isNonProd
        ? `ERROR! CHECK CONSOLE LOGS >> ${JSON.stringify(action)}`
        : DEFAULT_MESSAGE;

      const { noAlert } = action.payload;
      const error = action.payload.error
        ? action.payload.error
        : action.payload;

      if (noAlert) {
        return { ...state };
      }

      if (
        action.payload.error.message === SESSION_EXPIRED_ERROR ||
        (typeof action.payload.error === 'string' &&
          action.payload.error.includes(SESSION_EXPIRED_ERROR))
      ) {
        return { ...state };
      }

      const message =
        error.response?.data?.data?.message ||
        error.response?.data?.message ||
        _defaultMessage;

      if (error?.name === 'ServerError') {
        if (error.response.data?.data) {
          return {
            ...state,
            primaryAlert: {
              ...state.primaryAlert,
              message,
              type: 'error',
              show: true,
              errorData: error.response.data,
            },
          };
        }
      }

      return {
        ...state,
        primaryAlert: {
          ...state.primaryAlert,
          message,
          type: 'error',
          show: true,
          errorData: error,
        },
      };
    }

    default: {
      return state;
    }
  }
};

export default appbarReducer;
